
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 24","fill":"#5C6970","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.75.313h13.938l2.562 2.406 2.25 2.125V23H.75V.312z","fill":"#FFF"}}),_c('circle',{attrs:{"cx":"6.5","cy":"9.5","r":"2.203","fill":"#fff"}}),_c('path',{attrs:{"d":"M6.5 12A2.502 2.502 0 014 9.5C4 8.121 5.121 7 6.5 7S9 8.121 9 9.5 7.879 12 6.5 12zm0-4C5.673 8 5 8.673 5 9.5S5.673 11 6.5 11 8 10.327 8 9.5 7.327 8 6.5 8z"}}),_c('path',{attrs:{"d":"M8.5 16.344l3.156-4.407 4.531 7.532H3.47l3.469-5.094L8.5 16.344z","fill":"#fff"}}),_c('path',{attrs:{"d":"M3.5 20a.5.5 0 01-.424-.765l3.014-4.822a.998.998 0 011.697 0l.651 1.043 2.215-3.543a.996.996 0 01.846-.469c.348 0 .665.176.849.47l4.576 7.322A.5.5 0 0116.5 20h-13zm12.098-1L11.5 12.443l-2.639 4.222a.498.498 0 01-.848 0l-1.075-1.721L4.402 19h11.196z"}}),_c('path',{attrs:{"d":"M1.5 24C.673 24 0 23.327 0 22.5v-21C0 .673.673 0 1.5 0h13.293c.401 0 .777.156 1.061.439l3.707 3.707c.283.284.439.661.439 1.061V22.5c0 .827-.673 1.5-1.5 1.5h-17zm0-23a.5.5 0 00-.5.5v21a.5.5 0 00.5.5h17a.5.5 0 00.5-.5V5.207a.501.501 0 00-.146-.354l-3.707-3.707A.505.505 0 0014.793 1H1.5z"}})])
          )
        }
      }
    